import { render } from "./Recaptchav2Step.vue?vue&type=template&id=2d58d13a"
import script from "./Recaptchav2Step.vue?vue&type=script&lang=js"
export * from "./Recaptchav2Step.vue?vue&type=script&lang=js"

import "./Recaptchav2Step.vue?vue&type=style&index=0&id=2d58d13a&lang=css"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ui/Recaptchav2Step.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d58d13a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d58d13a', __exports__)) {
    console.log('reload')
    api.reload('2d58d13a', __exports__)
  }
  
  module.hot.accept("./Recaptchav2Step.vue?vue&type=template&id=2d58d13a", () => {
    console.log('re-render')
    api.rerender('2d58d13a', render)
  })

}


export default __exports__